export default class ShowcaseOverviewFilter {
    constructor() {
        this.drawer = document.getElementById('filterPanel');
        this.openBtn = document.querySelector('.js-showcase-filter-toggle');
        this.closeBtn = this.drawer && this.drawer.querySelector('.filter-panel__close');

        if (!this.drawer || !this.openBtn || !this.closeBtn) {
            return;
        }

        this.openBtn.setAttribute('aria-expanded', 'false');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.drawer.setAttribute('tabindex', '-1');

        this.openBtn.addEventListener('click', () => this.togglePanel());
        this.openBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.togglePanel();
            }
        });

        this.closeBtn.addEventListener('click', () => this.closePanel());
        this.closeBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
                e.preventDefault();
                this.closePanel();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.drawer.classList.contains('filter-panel--visible')) {
                this.closePanel();
            }
        });

        this.initAccordions();
        this.initClearButton();
    }

    togglePanel() {
        if (this.drawer.classList.contains('filter-panel--visible')) {
            this.closePanel();
        } else {
            this.openPanel();
        }
    }

    openPanel() {
        this.drawer.classList.remove('filter-panel--hidden');
        this.drawer.offsetWidth;
        this.drawer.classList.add('filter-panel--visible');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.drawer.removeAttribute('inert');
        this.drawer.setAttribute('tabindex', '0');
        this.openBtn.setAttribute('aria-expanded', 'true');
        setTimeout(() => {
            this.closeBtn.focus();
        }, 150);
    }

    closePanel() {
        this.drawer.classList.remove('filter-panel--visible');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.drawer.setAttribute('tabindex', '-1');
        this.openBtn.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
            this.drawer.setAttribute('inert', '');
            this.drawer.classList.add('filter-panel--hidden');
            this.openBtn.focus();
        }, 300);
    }

    initAccordions() {
        const toggles = this.drawer.querySelectorAll('.js-accordion-toggle');
        toggles.forEach(toggle => {
            const targetId = toggle.getAttribute('aria-controls');
            const content = document.getElementById(targetId);
            toggle.addEventListener('click', () => {
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
                toggle.setAttribute('aria-expanded', (!isExpanded).toString());
                content.hidden = isExpanded;
            });
            toggle.addEventListener('keydown', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggle.click();
                }
            });
        });
    }

    initClearButton() {
        const clearButton = this.drawer.querySelector('#filterClear');
        const form = this.drawer.querySelector('#filterForm');
        if (!clearButton || !form) {
            return;
        }
        clearButton.addEventListener('click', (e) => {
            e.preventDefault();
            form.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
            const hiddenSearchField = form.querySelector('input[name="Search"]');
            if (hiddenSearchField) {
                hiddenSearchField.value = '';
            }
            form.setAttribute('action', window.location.pathname);
            form.submit();
        });
    }
}
